import { render } from "./event_register_direct.vue?vue&type=template&id=0fe32b3c&scoped=true"
import script from "./event_register_direct.vue?vue&type=script&lang=js"
export * from "./event_register_direct.vue?vue&type=script&lang=js"

import "./event_register_direct.vue?vue&type=style&index=0&id=0fe32b3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe32b3c"]])

export default __exports__